import { init, showReportDialog } from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';

export function sentryInit(
  isProd: boolean,
  buildNumber: string | undefined,
  tracesSampler?: (samplingContext: {
    transactionContext?: { op?: string };
  }) => number | boolean
) {
  if (isProd) {
    const release = `heicconvert@${buildNumber ?? 0}`;
    init({
      dsn: 'https://3d0484be250447dda3ca9803cec2e067@o241437.ingest.sentry.io/4504552937291776',
      integrations: [new BrowserTracing()],
      tracesSampler,
      beforeSend(event, hint) {
        if (event?.extra?.noFeedback === true) {
          return event;
        }

        if (event.exception) {
          showReportDialog({ eventId: event.event_id });
        }

        return event;
      },
      autoSessionTracking: true,
      release,
      // tunnel: '/skildvagt/tunnel',
    });
  }
}
